var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hi"},[_c('div',{staticClass:"right bar"},[_c('div',{staticClass:"door",style:({bottom:_vm.countBar(_vm.list,_vm.m)*10+'%'})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }